var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOr1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 600,
    viewBox: "0 0 586 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M333.024 112.653C333.024 90.4323 315.011 72.419 292.79 72.419C270.57 72.419 252.557 90.4323 252.557 112.653C252.557 134.873 270.57 152.887 292.79 152.887C315.011 152.887 333.024 134.873 333.024 112.653Z",
    fill: "url(#paint0_linear_4225_27742)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M275.287 300C275.287 506.584 174.546 592.866 20.1216 599.573C9.08634 600.052 0.079207 590.912 0.191206 579.866C2.47782 354.365 45.2709 362.714 192.678 316.648C210.238 311.16 210.677 287.585 193.29 281.569C45.2724 230.357 2.3706 247.55 0.0968959 20.1427C-0.0135376 9.09751 8.91349 -0.0240375 19.8515 1.51484C106.833 13.7524 275.287 101.138 275.287 300Z",
    fill: "url(#paint1_linear_4225_27742)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M310.295 300C310.295 506.584 411.036 592.866 565.461 599.573C576.496 600.052 585.503 590.912 585.391 579.866C583.105 354.365 540.311 362.714 392.904 316.648C375.344 311.16 374.905 287.585 392.292 281.569C540.31 230.357 583.211 247.55 585.485 20.1427C585.595 9.09751 576.668 -0.0240343 565.73 1.51487C478.749 13.7525 310.295 101.138 310.295 300Z",
    fill: "url(#paint2_linear_4225_27742)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4225_27742",
    x1: 0,
    y1: 300,
    x2: 585.582,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0104167,
    stopColor: "#EDD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D5A6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963542,
    stopColor: "#7F56D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4225_27742",
    x1: 0,
    y1: 300,
    x2: 585.582,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0104167,
    stopColor: "#EDD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D5A6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963542,
    stopColor: "#7F56D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4225_27742",
    x1: 0,
    y1: 300,
    x2: 585.582,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0104167,
    stopColor: "#EDD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D5A6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963542,
    stopColor: "#7F56D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOr1);
export default __webpack_public_path__ + "static/media/or1.63631890098318deea6aa296664dadec.svg";
export { ForwardRef as ReactComponent };